// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2CHTs","itemTitle":"ClientEmergencyInfo_itemTitle__FeZlu","itemText":"ClientEmergencyInfo_itemText__4mcM5"};